import { SPORT_ARTWORK_ASSETS } from './sport-artwork-assets';
import { sportArtworkPixelSize } from './sport-artwork-size';

/** Vite imports URLs; Next.js imports image metadata containing the URL. */
export function resolveSportArtworkSource(asset: unknown): string {
  if (typeof asset === 'string') return asset;
  if (asset && typeof asset === 'object' && 'src' in asset && typeof asset.src === 'string') {
    return asset.src;
  }
  throw new Error('Invalid Lift sport artwork asset');
}

/** Shared Lift source for web components and string-composed map pins. */
export function getSportArtworkUrl(sport: string, size: number, density = 2): string | undefined {
  const resources = SPORT_ARTWORK_ASSETS[sport];
  if (resources === undefined) return undefined;
  return resolveSportArtworkSource(resources[sportArtworkPixelSize(size, density)]);
}
